<script>
import Layout from "../../layouts/auth";
import appConfig from "@/app.config";
//import countTo from 'vue-count-to';
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import AuthApi from "@/services/auth-api";
import BecomeMember from "@/components/become-member"
import LoginForm from "@/components/LoginForm"


// import NprogressContainer from 'vue-nprogress/src/NprogressContainer'

/**
 * Login component
 */
export default {
  page: {
    title: "Authentification",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Layout/*, NprogressContainer, countTo*/, VueSlickCarousel, BecomeMember, LoginForm },
    data() {
    return {
      email: "",
      password: "",
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,

      logos:[],

      showLogin: false,
      showBecomeMember: false,
      authenForm: true,
      startCounter: false,

      partnersSettings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        dots: false,
        responsive: [
          {
            breakpoint: 1200,
            settings: { slidesToShow: 4 }
          },
          {
            breakpoint: 992,
            settings: { slidesToShow: 3 }
          },
          {
            breakpoint: 576,
            settings: { slidesToShow: 2 }
          }
        ]
      },

      statsList: [  
        {
          icon: 'fas fa-capsules',
          class: 'text-dark',
          value: 180,
          title: 'PHARMACIENS',
          subtitle: 'Adhérents',
          duration: 3000
        },
        {
          icon: 'far fa-handshake',
          class: 'text-dark',
          value: 30,
          title: 'FOURNISSEURS',
          subtitle: 'Partenaires',
          duration: 2500
        },
        {
          icon: 'fas fa-chart-line',
          class: 'text-dark',
          value: 2500,
          title: 'COMMANDES',
          subtitle: 'Établies',
          duration: 2500
        }
      ],

      whyJoinList: [
        {
          icon: 'fas fa-bolt',
          title: 'Optimiser les achats',
          description:
            'Bénéficiez d’outils digitaux pour booster vos ventes et fidéliser vos clients.'
        },
        {
          icon: 'fas fa-handshake',
          title: 'Mutualiser la force du réseau',
          description:
            'Rejoignez le premier groupement pharmaceutique en Tunisie et développez votre réseau.'
        },
        {
          icon: 'fas fa-chart-line',
          title: 'Améliorer la rentabilité',
          description:
            'Accédez à des conditions préférentielles et améliorez votre performance d’achat.'
        },
        {
          icon: 'fas fa-puzzle-piece',
          title: 'Simplifier la gestion au quotidien',
          description: 'Intégrez le premier groupement pharmaceutique en Tunisie et facilitez la gestion de votre réseau.'
        }
      ],

      benefits: [
        {
          //icon: 'fas fa-bolt',
          title: 'Favoriser votre Sell-In',
          description:
            'Bénéficiez des promotions négociées spécialement pour les adhérents'
        },
        {
          //icon: 'fas fa-handshake',
          title: 'Développez votre Sell-Out',
          description:
            'Augmenter vos ventes grâce aux prix de vente concurrentiels'
        },
        {
          //icon: 'fas fa-puzzle-piece',
          title: 'Rejoingez le Groupement',
          description: 'Faire partie du premier et seul groupement pharmaceutique en Tunisie'
        }
      ]

    };
  },
 
  methods: {
 
  goToStatsSection() {

    this.$nextTick(() => {
      const section = this.$refs.statsSection;
      if (!section) return;

      const offset = 80;
      const y =
        section.getBoundingClientRect().top +
        window.pageYOffset -
        offset;

      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    });
  },

    getLogos(){
      AuthApi.getSuppliersImages().then(
        response => {
          this.logos = response;
        }
      )
    },

    openLogin() {
      this.closeShowBecomeMember()
      setTimeout(() => {
        this.showLogin = true
      }, 10)
    },

    closeLogin() {
      this.showLogin = false
    },

    openShowBecomeMember() {
      this.closeLogin()
      setTimeout(() => {
        this.showBecomeMember = true
      }, 10)
    },

    closeShowBecomeMember() {
      this.showBecomeMember = false
    },

    goToDiscover() {
      this.closeShowBecomeMember()
      this.closeLogin()
      const el = this.$refs.DiscoverLGP
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      }
    },

    goToPartners() {
      this.closeShowBecomeMember()
      this.closeLogin()
      const el = this.$refs.partnersSection
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      }
    },

    goToFooter() {
      this.closeShowBecomeMember()
      this.closeLogin()
      const el = this.$refs.footerSection
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      }
    }

  },

  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  },


  mounted() {
      document.body.style.background='#fff';
      this.getLogos();


    /*const observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            this.startCounter = true;
            observer.disconnect();
          }
        },
        { threshold: 0.3 }
      );
      observer.observe(this.$refs.statsSection);*/
    
  }
};
</script>

<template>
  <Layout>


  <div class="navbar-header"  >
 
    <header id="page-topbar" style="z-index: 100;"  >

      <div class="navbar-header" >

        <div class="row w-100 m-sm-4 m-0" >

          <div class="header-class col-1 col-md-6 col-lg-6 col-xl-3 col-xxl-3">
              <div class="d-flex mobile-user-button">
                <div class="my-auto" >
                  <router-link to="/" class="logo  " id="logo" >
                    <span class="logo-sm">

                      <img class="ml-2" src="@/assets/images/logo-dark.png" alt height="35" />
                    </span>
                    <span class="logo-lg">

                      <img class="ml-2" src="@/assets/images/logo-dark.png" alt height="50" />
                    </span>
                  </router-link>
                </div>
              </div>
          </div>

          <div class="col-0 col-md-0 col-lg-0 col-xl-6 col-xxl-6 d-none d-xl-block my-auto" style="margin-top: 0px !important;margin-bottom: 0px !important;">
            <div class="my-auto" style="height:100%;" >
              <div class="menu">
              <ul style="margin:0px;height:100%;"> 
                  <li>
                    <a href="#"> Accueil</a>
                  </li>
                  <li @click="goToDiscover">
                    <a>Découvrir LGP</a>
                  </li>
                  <li @click="openShowBecomeMember">
                    <a>Devenir adhèrent</a>
                  </li>
                  <li @click="goToPartners">
                    <a>Partenaires</a>
                  </li>
                  <li @click="goToFooter">
                    <a>Contact</a>
                  </li>

                </ul> 
              </div>
            </div>
          </div>

          <div class="col-11 col-md-6 col-lg-6 col-xl-3 col-xxl-3 text-right">
            <div class="btn header-item noti-icon d-flex align-items-center float-right">
              <b-button
                variant="primary"
                class="font-weight-bold font-size-16 pl-4 pr-4 pt-1 pb-1" block
                @click="openLogin"
              >
                Se Connecter
              </b-button>
            </div>
          </div>

        </div>

      </div>

    </header>

  </div>



<!-- MAIN BANNER -->

    <div class="row pt-xl-0" >
      <div class="col-12">
            <b-carousel
                class="homepage-carousel"
                img-width="1920"
                img-height="400"
                :interval="6000"
                :controls="false"
                :indicators="false"
                :fade="true"
              >
                  <b-carousel-slide>
                  <template #img>
                    <div class="banner-overlay"></div>

                    <!-- Desktop image -->
                    <img
                      src="@/assets/images/background/homepage.png"
                      alt="LGP"
                      class="banner-image d-none d-sm-block"
                    />

                    <!-- Mobile image -->
                    <img
                      src="@/assets/images/background/homepage_mobile.png"
                      alt="LGP"
                      class="banner-image d-block d-sm-none"
                    />
                  </template>
                </b-carousel-slide>

                <!-- CAPTION -->
                <div class="banner-caption w-100">
                  
                  <!-- DESKTOP -->
                  <div class="d-none d-sm-block text-md-left text-center px-5">
                    
                    <!--h1 class=" font-weight-bold banner-title-white text-primary text-lg-left text-center " style="font-size:6rem !important; font-weight:900 !important;">
                      <img src="@/assets/images/logo-dark.png" alt height="90" />
                    </h1>
                    <h2 class="d-none d-md-block text-primary mt-4 banner-title-white text-lg-left text-center" style="font-weight:900 !important; font-size:2.5rem !important;">Le premier groupement </h2>
                    <h2 class="d-none d-md-block text-primary mt-1 banner-title-white text-lg-left text-center" style="font-weight:900 !important; font-size:2.5rem !important;">pharmaceutique en Tunisie</h2-->
                    <h1 class="banner-title-white text-primary"><img src="@/assets/images/logo-dark.png" alt height="90" /></h1>
                    <h2 class="banner-subtitle text-primary mt-4">
                      Le premier groupement
                    </h2>
                    <h2 class="banner-subtitle text-primary">
                      pharmaceutique en Tunisie
                    </h2>

                    <p class="banner-paragraph text-primary mt-4">
                      Un réseau professionnel moderne qui optimise vos achats,
                      renforce vos marges et simplifie la gestion de votre officine.
                    </p>
                    <div class="mt-4">
                      <b-button variant="primary" class="btn-lg font-weight-bold mr-2"
                        @click="goToDiscover">
                          Découvrir LGP
                        </b-button>
                      <!--/a>    
                      
                      <a class="pl-2" >
                        <b-button variant="outline-info"  style="padding: 15px 20px 15px 20px; letter-spacing:1.5px; border-radius:8px; border:1px solid #1f3a56;" class="font-weight-bold text-primary bg-white font-size-18 "
                        @click="openShowBecomeMember"-->
                        <b-button variant="outline-info" class="btn-lg font-weight-bold text-primary bg-white ml-2"
                            @click="openShowBecomeMember">
                          Devenir adhérent 
                        </b-button>   
                    </div>
                  </div>

                    <!-- MOBILE -->
                  <div class="d-block d-sm-none text-center px-3">
                    <h1 class="banner-title-white text-primary mb-3"><img src="@/assets/images/logo-dark.png" alt height="35" /></h1>

                      <h2 class="banner-subtitle text-primary mb-3">
                      Le premier groupement pharmaceutique en Tunisie
                    </h2>

                      <p class="banner-paragraph text-primary mb-4">
                        Un réseau professionnel moderne qui optimise vos achats,
                        renforce vos marges et simplifie la gestion de votre officine.
                      </p>

                      <b-button
                        variant="primary"
                        class="btn-lg font-weight-bold mb-2 w-100"
                        @click="goToDiscover"
                      >
                        Découvrir LGP
                      </b-button>

                      <b-button variant="outline-light" class="btn-lg font-weight-bold text-primary w-100"
                        @click="openShowBecomeMember"
                      >
                        Devenir adhérent
                      </b-button>
                  </div>

                </div>
            </b-carousel>
      </div>
    </div>
    
<!-- END MAIN BANNER -->

<div ref="DiscoverLGP" id="discover-lgp" class="section-bg">
  <div class="">

        <!-- Title -->
    <div class="row mb-4 mt-4">
      <div class="col-12 text-center">
        <h2 class="why-title text-primary">LGP, un réseau créé par des pharmaciens pour les pharmaciens</h2>
        <p class="why-subtitle text-primary mt-4 font-size-20">
          LGP fédère aujourd'hui plus que 150 officinaux autour d'une vision commune
        </p>
      </div>
    </div>

     <!-- Cards -->
    <div class="row justify-content-center">
      <div
        v-for="(item, index) in whyJoinList"
        :key="index"
        class="col-lg-3 col-md-6 mb-4"
      >
        <div class="why-card m-3">
          <div class="why-icon bg-success">
            <i :class="item.icon"></i>
          </div>

          <h5 class="text-success text-uppercase">{{ item.title }}</h5>
          <p class="text-primary">{{ item.description }}</p>
        </div>
      </div>
    </div>

    
  </div>
</div>

    
<!--div ref="statsSection" id="stats-section" class="stats-section section-bg">
  <div class="container">

    <div class="row mb-4">
      <div class="col-12 text-center">
        <h2 class="why-title text-primary">Nos Chiffres</h2>
        <p class="partners-subtitle">
          Nos chiffres clés illustrent notre expertise et notre engagement auprès de nos partenaires
        </p>
      </div>
    </div>

    <div class="row justify-content-center text-center">

      <div
        v-for="(item, index) in statsList"
        :key="index"
        class="col-lg-4 col-md-6 mb-4"
      >
        <div class="stat-card p-4 m-4 shadow-sm rounded-lg m-3" style="border:1px solid #ddd">
          <div class="stat-icon mb-3">
            <i :class="item.icon + ' ' + item.class" :style="{ fontSize: '50px' }"></i>
          </div>
          <span class="d-block font-italic mb-2">plus de</span>
          <countTo 
            v-if="startCounter"
            class="stat-number text-success mb-3" 
            :autoplay="true" 
            :separator="' '" 
            :startVal="0" 
            :endVal="item.value" 
            :duration="item.duration"
          ></countTo>
          <h4 class="stat-title text-success mt-2">{{ item.title }}</h4>
          <h5 class="stat-subtitle text-uppercase text-success font-weight-bold">{{ item.subtitle }}</h5>
        </div>
      </div>

    </div>
  </div>
</div-->




<!--section class="section-bg" ref="DiscoverLGP">
  <div class="container-fluid">

    <div class="row mb-4">
      <div class="col-12 text-center">
        <h2 class="why-title text-primary">Pourquoi nous rejoindre ?</h2>
        <p class="why-subtitle">
          Des avantages concrets pour développer votre activité
        </p>
      </div>
    </div>

    <div class="row justify-content-center">
      <div
        v-for="(item, index) in whyJoinList"
        :key="index"
        class="col-lg-3 col-md-6 mb-4"
      >
        <div class="why-card m-3">
          <div class="why-icon bg-success">
            <i :class="item.icon"></i>
          </div>

          <h5 class="text-success">{{ item.title }}</h5>
          <p class="text-primary">{{ item.description }}</p>
        </div>
      </div>
    </div>

  </div>
</section-->


<section class="white-section text-center">
  <div class="container-fluid">

    <!-- Title -->
    <div class="row mb-4">
      <div class="col-12 text-center">
        <h2 class="why-title text-primary">Rejoignez la communauté LGP</h2>
        <p class="why-subtitle text-primary">
          En intégrant <strong>LGP</strong>, vous bénéficiez d’avantages exclusifs,
          d’un accompagnement personnalisé, d’outils modernes et d’offres négociées.
        </p>
      </div>
    </div>

    <div class="row justify-content-center">
      <div
        v-for="(item, index) in benefits"
        :key="index"
        class="col-lg-3 col-md-6 mb-4"
      >
        <div class="benefit-card m-3">
         
          <h5 class="text-success font-size-20">{{ item.title }}</h5>
          <p class="text-primary font-weight-bold">{{ item.description }}</p>
        </div>
      </div>
    </div>

    <b-button variant="success"  style="padding: 15px 20px 15px 20px; letter-spacing:1.5px; border-radius:8px;" class="mt-5 sfont-weight-bold font-size-18 font-weight-bold text-uppercase "
      @click="openShowBecomeMember">
        Devenir adhérent maintenant
    </b-button>   

  </div>
</section>


<section class="section-bg" ref="partnersSection" id="partners-section">
  <div class="container-fluid">

    <!-- Title -->
    <div class="row mb-4">
      <div class="col-12 text-center">
        <h2 class="why-title text-primary">Nos Fournisseurs Partenaires</h2>
        <p class="partners-subtitle">
          Découvrez les partenaires de confiance qui contribuent au succès de nos services
        </p>
      </div>
    </div>

    <div class="partners-carousel">
      <VueSlickCarousel v-if="logos && logos.length" v-bind="partnersSettings">
        <div v-for="(logo, index) in logos" :key="index" >
          <div class="partner-card py-4 m-4">
            <img
              :src="'/api/image/get/' + logo "
              alt="Logo"
              height="70px"
            />
          </div>

        </div>
      </VueSlickCarousel>
    </div>

  </div>
</section>


<footer class="footer-main bg-primary text-light" ref="footerSection">
  <div class="container-fluid">
    <div class="row py-5">

      <!-- Spacer for large screens -->
      <div class="col-1 d-none d-md-block"></div>

      <!-- LOGO + DESCRIPTION -->
      <div class="col-lg-4 col-md-4 mb-4 text-center text-md-left">
        <img
          src="@/assets/images/logo-light.png"
          alt="LGP"
          height="90"
          class="mb-3"
        />

        <p class="footer-text mx-md-0 mx-2">
          LGP – Le Groupement Pharmaceutique est un réseau professionnel
          dédié à l’optimisation des achats et à la performance des officines.
        </p>

        <div class="footer-socials mt-3">
          <a href="#" aria-label="Facebook"><i class="fab fa-facebook-f"></i></a>
          <a href="#" aria-label="LinkedIn"><i class="fab fa-linkedin-in"></i></a>
        </div>
      </div>

      <!-- LIENS RAPIDES -->
      <div class="col-lg-2 col-md-2 mb-4 text-center text-md-left">
        <h5 class="footer-title">Liens rapides</h5>
        <ul class="footer-links list-unstyled">
          <li><div class="link">Accueil</div></li>
          <li @click="goToDiscover"><div class="link">Découvrir LGP</div></li>
          <li @click="openShowBecomeMember"><div class="link">Devenir adhérent</div></li>
        </ul>
      </div>

      <!-- SUPPORT -->
      <div class="col-lg-2 col-md-2 mb-4 text-center text-md-left">
        <h5 class="footer-title">Espace Client</h5>
        <ul class="footer-links list-unstyled">
          <li @click="openLogin"><div class="link">Commandes</div></li>
          <li @click="openLogin"><div class="link">Catalogue</div></li>
        </ul>
      </div>

      <!-- CONTACT -->
      <div class="col-lg-2 col-md-2 mb-4 text-center text-md-left">
        <h5 class="footer-title">Contact</h5>

        <p class="footer-contact">
          <i class="fas fa-envelope mr-2"></i>
          <a href="mailto:contact@lgp.tn">contact@lgp.tn</a>
        </p>

        <p class="footer-contact">
          <i class="fas fa-phone mr-2"></i>
          +216 20 412 142
        </p>

        <p class="footer-contact">
          <i class="fas fa-map-marker-alt mr-2"></i>
          Tunisie
        </p>
      </div>

    </div>

    <!-- BOTTOM BAR -->
    <div class="row footer-bottom py-3 align-items-center px-3 border-top border-light">
      <div class="col-md-6 text-md-left text-center mb-2 mb-md-0">
        © {{ currentYear }} LGP — Tous droits réservés
      </div>

      <div class="col-md-6 text-md-right text-center">
        <a href="#" class="footer-bottom-link text-light">Mentions légales</a>
        <span class="mx-2">|</span>
        <a href="#" class="footer-bottom-link text-light">Politique de confidentialité</a>
        <span class="mx-2">|</span>
        Powered by
        <a href="https://www.amiral.io" target="_blank" class="text-light font-weight-bold">Amiral</a>
      </div>
    </div>

  </div>
</footer>

  <transition name="become-member-slide">
    <div v-if="showBecomeMember" class="become-member-overlay">
      <div class="become-member-wrapper">
        <div class="become-member-card">
          <BecomeMember @closeBecomeMember="closeShowBecomeMember" />
        </div>
      </div>
    </div>
  </transition>



  <transition name="login-slide">
    <div v-if="showLogin" class="login-overlay">
      <LoginForm @close="closeLogin" ></LoginForm>
    </div>
  </transition>


  </Layout>
</template>

<style lang="scss" scoped>
.dropdown-border{
  border-bottom:3px solid #000;
   border-radius:0px;
}
.menu li.active a,
.menu li a:hover {
  color: #297a54 !important;
}

.menu {
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    width: 100%;
    height: 100%;
    -ms-overflow-style: none;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
}

.menu ul {
  display: flex;
  align-items: center;
  justify-content: space-around;
  list-style: none;
  padding: 0;
  margin: 0;
  height: 100%;
}

.menu ul li a {
  text-decoration: none;
  padding: 10px 15px;
  display: block;
  color: #1f3a56;
  font-weight: 500;
  font-size:1rem;
  cursor: pointer;
}
/* Carousel */
.homepage-carousel {
  /*box-shadow: 0 2px 6px rgb(0 0 0 / 8%);*/
}

/* Images */
.banner-image {
  width: 100%;
  min-height: 420px;
  object-fit: cover;
}

/* Overlay */
.banner-overlay {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  background: linear-gradient(
    to left,
    rgba(255, 255, 255, 0) 40%,
    rgba(255, 255, 255, 1) 60%
  );
}

/* Mobile overlay */
@media (max-width: 767.98px) {
  .banner-overlay {
    background: linear-gradient(
      to top,
      rgba(255, 255, 255, 1) 40%,
      rgba(255, 255, 255, 0) 100%
    );
  }
}

/* Caption */
.banner-caption {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  z-index: 2;
}

/* Mobile caption */
@media (max-width: 767.98px) {
  .banner-caption {
    top: auto;
    bottom: 1.5rem;
    transform: none;
  }
}

/* Titles */
.banner-title-white {
  font-size: clamp(2.2rem, 5vw, 6rem);
  font-weight: 900;
  letter-spacing: 2px;
  text-shadow: 2px 2px 10px #fff;
}

.banner-subtitle {
  font-size: clamp(1.2rem, 3vw, 2.5rem);
  font-weight: 900;
}

/* Text */
.banner-paragraph {
  font-size: clamp(1rem, 2.5vw, 1.3rem);
  max-width: 520px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

/* md and up → left aligned */
@media (min-width: 768px) {
  .banner-paragraph {
    margin-left: 0;
    margin-right: 0;
    text-align: left;
  }
}


/* Buttons */
.btn-lg {
  padding: 14px 22px;
  border-radius: 8px;
  letter-spacing: 1.2px;
}

</style>


<style scoped>

.become-member-wrapper {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: radial-gradient(circle at center, #ffffff 0%, #f2f5f9 100%);
}

.become-member-card {
  width: 100%;
  max-width: 550px;
  padding: 40px 30px;
  background: transparent;
  text-align: center;
}

.become-member-overlay {
  position: fixed;
  inset: 0;
  background: radial-gradient(circle, #ffffff 0%, #f2f5f9 100%);
  z-index: 9999;
  overflow-y: auto;
}

.become-member-slide-enter-active {
  animation: slideFadeIn 0.6s ease forwards;
}

.become-member-slide-leave-active {
  animation: slideFadeOut 0.4s ease forwards;
}

@keyframes slideFadeIn {
  from {
    opacity: 0;
    transform: translateY(-40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideFadeOut {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-30px);
  }
}

</style>



<style scoped>


.header-class{
   z-index: 100000;
}
.login-overlay {
  position: fixed;
  inset: 0;
  background: radial-gradient(circle, #ffffff 0%, #f2f5f9 100%);
  z-index: 1001;
  overflow-y: auto;
}

.fade-page-enter-active,
.fade-page-leave-active {
  transition: opacity 0.4s ease;
}

.fade-page-enter,
.fade-page-leave-to {
  opacity: 0;
}

.login-slide-enter-active {
  animation: slideFadeIn 0.6s ease forwards;
}

.login-slide-leave-active {
  animation: slideFadeOut 0.4s ease forwards;
}

@keyframes slideFadeIn {
  from {
    opacity: 0;
    transform: translateY(-40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideFadeOut {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-30px);
  }
}

</style>


<!-- FOOTER STYLE -->

<style>
 
.footer-text {
  font-size: 15px;
  line-height: 1.7;
}

.footer-bottom {
  font-size: 14px;
}

.footer-main {
  color: #cfd8e3;
  font-size: 15px;
}

.footer-title {
  color: #ffffff;
  font-weight: 700;
  margin-bottom: 20px;
  position: relative;
}

@media (max-width: 768px) {
  .footer-title {
    margin-top: 20px;
  }
}


.footer-title::after {
  content: '';
  width: 30px;
  height: 3px;
  background: #34c38f;
  position: absolute;
  left: 0;
  bottom: -8px;
  border-radius: 2px;
}

/* Small screens */
@media (max-width: 767px) {
  .footer-title::after {
    left: 50%;
    transform: translateX(-50%);
  }
}


.footer-links {
  list-style: none;
  padding: 0;
}

.footer-links li {
  margin-bottom: 10px;
}

.link{
  cursor: pointer;
}

.footer-links .link {
  color: #cfd8e3;
  text-decoration: none;
  transition: all 0.3s ease;
}

.footer-links .link:hover {
  color: #34c38f;
  padding-left: 5px;
}

.footer-contact {
  margin-bottom: 12px;
}

.footer-contact a {
  color: #cfd8e3;
}

.footer-socials .link {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 38px;
  height: 38px;
  margin-right: 10px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  transition: all 0.3s ease;
}

.footer-socials .link:hover {
  background: #34c38f;
  color: #04162b;
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 14px;
  opacity: 0.9;
}

.footer-bottom .link {
  color: #cfd8e3;
  text-decoration: none;
}

.footer-bottom .link:hover {
  color: #34c38f;
} 



</style>




<!-- why-join-section -->

<style>

.section-bg {
  background: linear-gradient(135deg, #ffffff 0%, #f4f7fb 100%);
  padding: 80px 20px;
}

@media (max-width: 767.98px) {
  .section-bg {
    padding: 20px 20px;
  }
}

.why-title {
  font-size: 36px;
  font-weight: 800;
}

.why-subtitle {
  margin-top: 10px;
  color: #6c7a89;
  font-size: 17px;
}

.why-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 35px 25px;
  height: 100%;
  text-align: center;
  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.06);
  transition: all 0.35s ease;
}

.why-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.12);
}

.why-icon {
  width: 70px;
  height: 70px;
  margin: 0 auto 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 28px;
}

.why-card h5 {
  font-weight: 700;
  color: #1f3554;
  margin-bottom: 15px;
}

.why-card p {
  font-size: 15px;
  line-height: 1.6;
  color: #6c7a89;
}

.benefit-card {
  background: #fff;
  border-radius: 16px;
  padding: 35px 25px;
  text-align: center;
  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.06);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.benefit-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.1);
}


</style>


<!-- partners-section -->


<style>

.white-section {
  position: relative;
  padding: 80px 20px;
}

@media (max-width: 767.98px) {
  .white-section {
    padding: 20px 20px;
  }
}

.partners-title {
  font-size: 1.9rem;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 0.5rem;
}

.partners-subtitle {
  font-size: 0.95rem;
  color: #6c757d;
}

.partner-card {
  background: #fff;
  border-radius: 10px;
  border: 1px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.partner-card img {
  max-height: 60px;
  max-width: 100%;
  object-fit: contain;
  transition: all 0.3s ease;
}

.partner-card:hover {
  transform: translateY(-4px) scale(1.03);
  /*box-shadow: 
    0 8px 20px rgba(0, 0, 0, 0.15),
    0 0 15px rgba(52, 195, 143, 0.3);*/
  transition: all 0.3s ease;
}
</style>


<style>

.stats-section {
  background: linear-gradient(135deg, #ffffff 0%, #f4f7fb 100%);
  padding: 80px 20px;
}

@media (max-width: 767.98px) {
  .stats-section {
    padding: 20px 20px;
  }
}
.why-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.partners-subtitle {
  font-size: 1rem;
  color: #6c757d;
}

.stat-card {
  background: #fff;
  border-radius: 15px;
  padding: 30px 20px;
  transition: all 0.3s ease;
  box-shadow: 0 6px 20px rgba(0,0,0,0.08);
}

.stat-card:hover {
  transform: translateY(-5px) scale(1.03);
  box-shadow: 0 12px 25px rgba(52,195,143,0.25);
}

.stat-icon i {
  display: inline-block;
}

.stat-number {
  font-size: 60px;
  font-weight: 900;
}

.stat-title {
  font-size: 1.3rem;
  font-weight: 700;
}

.stat-subtitle {
  font-size: 0.95rem;
  color: #6c757d;
}



</style>